import { blobToBase64 } from './blobToBase64';

export const convertFileToBase64 = async (file: File) => {
  const base64File = await blobToBase64(file);
  const base64Data = base64File.split(',')[1];
  return {
    type: file.type,
    base64Data,
    name: file.name || '',
  };
};
